import { Transform } from 'class-transformer';
import { User } from './user';
// `Submission` is referenced by the `@Type` factory below. We CANNOT
// import it as a value because `paper.ts` imports Session back — that
// creates the cycle webpack warns about. Instead:
//   - `import type` brings in only the TYPE (erased at compile time).
//   - Runtime resolution happens via the class registry; see
//     `_class-registry.ts` for the full rationale.
import type { Submission } from './paper';
import { register, getClass } from './_class-registry';
import { BaseModel, toDayjs } from './baseModel';
import { Type } from 'class-transformer';
import * as dayjs from 'dayjs';

export class Session extends BaseModel {

  @Transform(toDayjs)
  public start: dayjs.Dayjs;

  @Transform(toDayjs)
  public end: dayjs.Dayjs;

  @Type(() => User)
  chair: User;

  // Lazy class lookup — the registry is populated when `paper.ts` is
  // evaluated (its module body calls `register('Submission', Submission)`).
  // The factory only runs at deserialization time, so the registry is
  // already populated by then.
  @Type(() => getClass<typeof Submission>('Submission'))
  submissions: Array<Submission>;

  constructor(
    public event: number,
    public title: string,
    public subtitle: string,
    public url: string,
    public room: string,
    public backgroundColor: string
  ) { super(); }

}

// Side-effect: register this class with the shared registry so other
// model files can resolve it without a static import (see the
// circular-dependency notes in `_class-registry.ts`).
register('Session', Session);
